import React, { useEffect, useRef } from 'react';
import styles from '../../styles/home.module.css';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import Messaging from './Messaging'
import Payroll from './Payroll'
import ActionTake from './actionTake/ActionTake'
import Absence from './Absence'
import Greetings from './Greetings'
import { getAllContent, sortDocument } from '../../actions/home'
import * as StatusCode from '../../scripts/StatusCode';
import AlertAlgo from '../controls/AlertSnack';
import { makeStyles } from '@material-ui/core/styles';
import * as keyMenu from '../../scripts/KeyMenu';
import { getAccessMenu } from '../../utils/menuNavigationHelper';

const useStyles = makeStyles((theme) => ({
    divRootHome: {
        marginLeft: 'auto',
        marginRight: 'auto',
        textAlign: '-webkit-center'
    },
    divCardsRoot: {
        maxWidth: '700px',
    },
    divRootGreetings: {
        margin: '0',
        width: '100%',
        borderRadius: 'unset',
        boxShadow: 'none',
        color: 'var(--color1)',
        borderBottom: '1px solid #d3d3d399',
        position: 'static'
    },
    divMessaging: {
        background: 'linear-gradient(#658ccd, #4e6793)',
        boxShadow: '1px 1px 7px 0px #a3a3a3',
        padding: '10px 8px',
        fontWeight: 'bold',
        marginTop: '30px'
    },
    messagingImg: {
        width: '45px',
        position: 'relative',
        float: 'right',
        bottom: '0px',
        right: '7px',
        marginTop: '-30px'
    },
    divPayroll: {
        padding: '10px 8px',
        marginTop: '30px',
        fontWeight: 'bold',
        background: 'linear-gradient(#36b1b9d4, #2c7478d4)',
        boxShadow: '1px 1px 7px 0px #4e4e4ead'
    },
    divActionTake: {
        color: '#333333',
        border: 'unset !important',
        boxShadow: 'unset !important',
        backgroundColor: 'unset !important',
        margin: '0px 0px 5px 0px',
        width: '100%'
    },
    divAbsence: {
        border: 'unset !important',
        boxShadow: 'unset !important',
        backgroundColor: 'unset !important',
        margin: '0px 0px 15px 0px !important',
        width: '100% !important'
    },
    divHRRequest: {
        border: 'unset !important',
        boxShadow: 'unset !important',
        backgroundColor: 'unset !important',
        margin: '0px 0px 15px 0px !important',
        width: '100% !important'
    },
    divTitlePayroll: {
        textAlign: 'left',
        color: '#666666',
        margin: '-25px 0 0 20px',
        fontWeight: 'bold'
    },
    divTitleMessage: {
        textAlign: 'left',
        color: '#666666',
        margin: '20px 0 0 20px',
        fontWeight: 'bold'
    },
    divTitleAction: {
        textAlign: 'left',
        color: '#666666',
        margin: '30px 0 0 20px',
        fontWeight: 'bold',
        fontVariant: 'all-small-caps',
        fontSize: '22px'
    },
    divTitleAbsence: {
        textAlign: 'left',
        color: '#666666',
        margin: '15px 0 0 20px',
        fontWeight: 'bold',
        fontVariant: 'all-small-caps',
        fontSize: '22px'
    },
    divTitleHRRequest: {
        textAlign: 'left',
        color: '#666666',
        margin: '15px 0 0 20px',
        fontWeight: 'bold',
        fontVariant: 'all-small-caps',
        fontSize: '22px'
    },
}));


function HomeContent(props) {
    const classes = useStyles();

    const [dataMessage, setDataMessage] = React.useState(null);
    const [dataPayroll, setDataPayroll] = React.useState(null);
    const [dataDocument, setDataDocument] = React.useState(null);
    const [showDocument, setShowDocument] = React.useState(false);
    const [showSurvey, setShowSurvey] = React.useState(false);
    const [dataSurvey, setDataSurvey] = React.useState(null);
    const [dataAbsence, setDataAbsence] = React.useState(null);
    const [useRequest, setUseRequest] = React.useState(false);
    const [useHRRequest, setUseHRRequest] = React.useState(false);
    const [dataHRRequest, setDataHRRequest] = React.useState(null);


    useEffect(() => {
        resize();
        loadHomeContent();
    }, []);

    const alertRef = useRef(null);

    const showMessageError = (message) => {
        alertRef.current.showMessageError(message);
    }

    const loadHomeContent = async () => {
        if (getAccessMenu(keyMenu.MENU_REQUEST)) {
            setUseRequest(true);
        }

        if (getAccessMenu(keyMenu.MENU_HRREQUEST)) {
            setUseHRRequest(true);
        }

        if (getAccessMenu(keyMenu.MENU_DOCUMENTS)) {
            setShowDocument(true);
        }

        if (getAccessMenu(keyMenu.MENU_SURVEY)) {
            setShowSurvey(true);
        }

        var result = await getAllContent();
        if (result.status === StatusCode.STATUS_OK) {
            setDataMessage(result.messages);
            setDataPayroll(result.payroll);
            setDataDocument(sortDocument(result.documents));
            setDataSurvey(result.surveys);
            setDataHRRequest(result.hrRequests);
            setDataAbsence(result.absences);
        } else {
            // Error
            const message = i18next.t('error:generic-error');
            showMessageError(message);
        }
    }

    const resize = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const divMenu = document.querySelector('#menuFavorite').clientHeight;
            const divGreetings = document.querySelector('#divGreetings')?.clientHeight;
            const offSet = 0;

            const customHeight = height - titleBar - divMenu - divGreetings - offSet;

            const element = document.querySelector('#divRootHome');

            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }
        }, 1000);
    }

    return (
        <div>
            <div id={"divGreetings"} className={`${styles.contentType} ${classes.divRootGreetings}`}>
                <div style={{ maxWidth: "700px", width: "calc(100% - 30px)", display: "inline-block" }}>
                    <Greetings />
                </div>
            </div>
            <div id={"divRootHome"} className={`${styles.contentRoot} ${classes.divRootHome}`}>
                <div className={classes.divCardsRoot}>
                    {(dataMessage != null && dataMessage.length > 0) &&
                        <div className={`${styles.contentType} ${classes.divMessaging}`}>
                            <Messaging data={dataMessage} />
                        </div>
                    }
                    <div className={`${styles.contentType} ${classes.divPayroll}`}>
                        <Payroll data={dataPayroll} />
                    </div>
                    <div className={classes.divTitleAction}>
                        <span>{i18next.t('home:homeContent.actionTake')}</span>
                    </div>
                    <div className={`${styles.contentType} ${classes.divActionTake}`}>
                        <ActionTake handleSelectedPage={props.handleSelectedPage} showDocument={showDocument} showSurvey={showSurvey} dataDocument={dataDocument} dataSurvey={dataSurvey} />
                    </div>

                    {useRequest &&
                        <div>
                            <div className={classes.divTitleAbsence}>
                                <span>{i18next.t('home:homeContent.nextAbsences')}</span>
                            </div>
                            <div className={`${styles.contentType} ${classes.divAbsence}`}>
                                <Absence handleSelectedPage={props.handleSelectedPage} data={dataAbsence} />
                            </div>
                            <AlertAlgo ref={alertRef} />
                        </div>
                    }

                    {useHRRequest &&
                        <div>
                            <div className={classes.divTitleHRRequest}>
                                <span>{i18next.t('home:homeContent.hrRequest')}</span>
                            </div>
                            <div className={`${styles.contentType} ${classes.divHRRequest}`}>
                                <Absence handleSelectedPage={props.handleSelectedPage} data={dataHRRequest} />
                            </div>
                            <AlertAlgo ref={alertRef} />
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}
export default withNamespaces(['HomeContent', 'error'], { wait: true })(HomeContent);